/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable jsx-a11y/img-redundant-alt */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useContext, useReducer, useState, useEffect } from "react";
import { format } from "date-fns";
import { Store } from "../Store";
import MoreVertSharpIcon from "@mui/icons-material/MoreVertSharp";
import axios from "axios";
import { toast } from "react-toastify";
import { getError } from "../LoadingError/Utils";
import Tooltip from "@mui/material/Tooltip";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import Typography from "@mui/material/Typography";
import Modal from "@mui/material/Modal";
import Box from "@mui/material/Box";
import { useNavigate } from "react-router-dom";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  border: "0.1px solid gainsboro",
  borderRadius: "1rem",
  boxShadow: "1px 2px 1px gainsboro",
  p: 4,
};

const reducer = (state, action) => {
  switch (action.type) {
    case "FETCHING":
      return { ...state, loading: true };
    case "FETCHED":
      return { ...state, dataUser: action.payload, loading: false };
    case "FETCH_FAILED":
      return { ...state, loading: false, error: action.payload };
    default:
      return state;
  }
};

const reducer2 = (state, action) => {
  switch (action.type) {
    case "ADD_REQUEST":
      return { ...state, loadingAdd: true };
    case "ADD_SUCCESS":
      return { ...state, loadingAdd: false };
    case "ADD_FAIL":
      return { ...state, loadingAdd: false };
    default:
      return state;
  }
};

const reducer3 = (state, action) => {
  switch (action.type) {
    case "FETCHING":
      return { ...state, loadingComments: true };
    case "FETCHED":
      return { ...state, dataComments: action.payload, loadingComments: false };
    case "FETCH_FAILED":
      return {
        ...state,
        loadingComments: false,
        errorComments: action.payload,
      };
    default:
      return state;
  }
};

const reducer4 = (state, action) => {
  switch (action.type) {
    case "DELETE_REQUEST":
      return { ...state, loadingDel: true };
    case "DELETE_SUCCESS":
      return { ...state, loadingDel: false };
    case "DELETE_FAIL":
      return { ...state, loadingDel: false };
    default:
      return state;
  }
};

const reducer5 = (state, action) => {
  switch (action.type) {
    case "FETCHING":
      return { ...state, loadingAllContactList: true };
    case "FETCHED":
      return {
        ...state,
        dataAllContactList: action.payload,
        loadingAllContactList: false,
      };
    case "FETCH_FAILED":
      return {
        ...state,
        loadingAllContactList: false,
        errorAllContactList: action.payload,
      };
    default:
      return state;
  }
};

const edits = ["Update Post", "Delete Post"];

const typeNames = {
  1: "Product",
  2: "Service",
  3: "Event",
  4: "Job",
  5: "Insight",
  6: "Education",
};

const getTypeName = (postType) => typeNames[postType] || "Unknown Type";

export default function PostPopup(props) {
  const { post } = props;
  const { state } = useContext(Store);
  const { userInfo } = state;
  const [anchorElPost, setAnchorElPost] = useState(null);
  const [showModalUpdate, setShowModalUpdate] = useState(false);
  const [showModalDelete, setShowModalDelete] = useState(false);
  const [showSignInModalChat, setShowSignInModalChat] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(0);

  const [likes, setLikes] = useState(
    (post && post.user_liked?.user_liked) || 0
  );
  const [totalLikes, setTotalLikes] = useState(
    parseInt(post?.total_likes || 0)
  );

  const isNull = !!post?.images;
  const imagess = post?.images || [];
  const createdDate = new Date(post?.created_at);

  const [socialMediaOptions, setSocialMediaOptions] = useState(true);

  const navigate = useNavigate();

  const readMoreStyle = {
    color: "#c2bebe",
    cursor: "pointer",
  };

  const nominal = post.price;
  const price =
    post &&
    post.price &&
    new Intl.NumberFormat("id-ID", {
      style: "currency",
      currency: post.abbreviation,
      maximumFractionDigits: 0,
    }).format(nominal);

  const [{ dataUser }, dispatch] = useReducer(reducer, {
    dataUser: [],
    loading: true,
    error: "",
  });

  const [{ loadingAdd }] = useReducer(reducer2, {
    loadingAdd: false,
  });

  const [, dispatch3] = useReducer(reducer3, {
    dataComments: [],
    loadingComments: true,
    errorComments: "",
  });

  const [{ loadingDel }] = useReducer(reducer4, {
    loadingDel: false,
  });

  const [{ dataAllContactList }, dispatch5] = useReducer(reducer5, {
    dataAllContactList: [],
    loadingAllContactList: true,
    errorAllContactList: "",
  });

  useEffect(async () => {
    if (userInfo !== null) {
      dispatch({
        type: "FETCHING",
      });
      try {
        const { data } = await axios.get(
          `${process.env.REACT_APP_BACKEND_DOMAIN}/api/users/me`,
          {
            headers: { Authorization: `Bearer ${userInfo.data.token}` },
          }
        );
        dispatch({
          type: "FETCHED",
          payload: data.data,
        });
      } catch (error) {
        dispatch({
          type: "FETCH_FAILED",
          payload: error.message,
        });
        toast.error(getError(error));
      }
    }
  }, []);

  useEffect(async () => {
    dispatch3({
      type: "FETCHING",
    });
    try {
      const { data } = await axios.get(
        `${process.env.REACT_APP_BACKEND_DOMAIN}/api/posts/getComment?postId=${post.id}`,
        {
          auth: {
            username: `${process.env.REACT_APP_BASIC_AUTH_USERNAME}`,
            password: `${process.env.REACT_APP_BASIC_AUTH_PASSWORD}`,
          },
        }
      );
      dispatch3({
        type: "FETCHED",
        payload: data.data,
      });
    } catch (error) {
      dispatch3({
        type: "FETCH_FAILED",
        payload: error.message,
      });
      toast.error(getError(error));
    }
  }, [loadingAdd, loadingDel]);

  useEffect(async () => {
    dispatch5({
      type: "FETCHING",
    });

    try {
      const { data } = await axios.get(
        `${process.env.REACT_APP_BACKEND_DOMAIN}/api/users/getAllContactList`,
        {
          headers: { Authorization: `Bearer ${userInfo.data.token}` },
        }
      );

      const socialMediaOptions = data.data.map((item) => ({
        value: item.id.toString(),
        label: item.name,
        image: item.image,
        url: item.url,
      }));

      dispatch5({
        type: "FETCHED",
        payload: data.data,
      });

      setSocialMediaOptions(socialMediaOptions);
    } catch (error) {
      dispatch5({
        type: "FETCH_FAILED",
        payload: error.message,
      });
    }
  }, [...dataAllContactList]);

  const openContact = (urlSocialMedia, usernameSocialMedia) => {
    if (dataAllContactList !== null) {
      if (urlSocialMedia) {
        let contactId = Object.keys(post.contact).find(
          (key) => post.contact[key].id === usernameSocialMedia.id
        );
        if (contactId !== undefined) {
          let url = dataAllContactList.find(
            (item) => item.id === contactId
          )?.url;

          // Check if the usernameSocialMedia.value starts with "http://" or "https://"
          if (
            usernameSocialMedia.value &&
            (usernameSocialMedia.value.startsWith("http://") ||
              usernameSocialMedia.value.startsWith("https://"))
          ) {
            url = usernameSocialMedia.value;
          } else {
            // If not, append it to the URL from dataAllContactList
            if (url === null) {
              url = "tel:" + getPhoneNumber(usernameSocialMedia.value);
            } else if (
              !url.startsWith("http://") &&
              !url.startsWith("https://")
            ) {
              url = "https://" + url;
            }
            url += usernameSocialMedia.value;
          }

          window.open(url);
        } else {
          alert("Contact not found!");
        }
      }
    }
  };

  const getPhoneNumber = () => {
    return "";
  };

  const autoHyperlink = (text) => {
    const urlPattern = /(https?:\/\/[^\s]+)/g;
    return text.split(urlPattern).map((part, index) =>
      urlPattern.test(part) ? (
        <a
          key={index}
          href={part}
          target="_blank"
          rel="noopener noreferrer"
          className="font-semibold text-[#F95C3D]"
        >
          {part}
        </a>
      ) : (
        part
      )
    );
  };

  const ReadMore = ({ children }) => {
    const text = children;
    const [showMore, setShowMore] = useState(true);
    const toggleReadMore = () => {
      setShowMore(!showMore);
    };

    if (text.length <= 100) {
      return (
        <p className="whitespace-pre-wrap break-words">{autoHyperlink(text)}</p>
      );
    } else {
      const sliceLimit = 100;
      const endOfSentence = text.lastIndexOf(" ", sliceLimit);
      const displayText = showMore
        ? text.slice(0, endOfSentence) + "..."
        : text;

      return (
        <p className="whitespace-pre-wrap break-words">
          {autoHyperlink(displayText)}
          <span
            onClick={toggleReadMore}
            className="whitespace-nowrap text-sm text-[#F95C3D] cursor-pointer"
          >
            {showMore ? " read more" : "show less"}
          </span>
        </p>
      );
    }
  };

  const UploadDate = ({ timestamp }) => {
    let currentDate = new Date();
    let uploadDate = new Date(timestamp);

    let diffDate = date_diff_indays(uploadDate, currentDate);
    let date = "";
    if (diffDate >= 604800) {
      date = Math.floor(diffDate / 604800) + "w";
      return date;
    } else if (diffDate >= 86400) {
      date = Math.floor(diffDate / 86400) + "d";
      return date;
    } else if (diffDate >= 3600) {
      date = Math.floor(diffDate / 3600) + "h";
      return date;
    } else if (diffDate >= 60) {
      date = Math.floor(diffDate / 60) + "m";
      return date;
    } else {
      if (diffDate < 0) {
        diffDate = 0;
      }
      date = diffDate + "s";
      return date;
    }
  };

  const formattedDate = createdDate.toLocaleString("en-US", {
    year: "numeric",
    month: "long",
    day: "2-digit",
  });

  const date_diff_indays = function (date1, date2) {
    const dt1 = new Date(date1);
    const dt2 = new Date(date2);
    return Math.floor(
      (Date.UTC(
        dt2.getFullYear(),
        dt2.getMonth(),
        dt2.getDate(),
        dt2.getHours(),
        dt2.getMinutes(),
        dt2.getSeconds()
      ) -
        Date.UTC(
          dt1.getFullYear(),
          dt1.getMonth(),
          dt1.getDate(),
          dt1.getHours(),
          dt1.getMinutes(),
          dt1.getSeconds()
        )) /
        1000
    );
  };

  function SetProfilePicture() {
    const isNull = post.picture;
    if (isNull === "null" || isNull === null) {
      return <DefaultPP />;
    } else {
      return <ProfilePicture />;
    }
  }

  function DefaultPP() {
    return (
      <img
        className="mb-3 mt-3 rounded-full w-10 h-10 lg:w-12 lg:h-12"
        src="../images/pp/defaultpp.png"
        alt="defaultprofilepicture"
        referrerPolicy="no-referrer"
      />
    );
  }

  function ProfilePicture() {
    return (
      <img
        className="mb-3 mt-3 rounded-full w-10 h-10 lg:w-12 lg:h-12"
        src={post.picture}
        alt="profilepicture"
        referrerPolicy="no-referrer"
      />
    );
  }

  function SetUsername() {
    if (post.username === null) {
      return (
        <div className="text-xs lg:text-sm">
          <div className="flex items-center">
            <span>{post.name}</span>
            <div className="flex items-center ml-2">
              {post.verified ? (
                <img
                  className="w-3 h-3"
                  alt="verified"
                  src="../../images/icon_done.png"
                ></img>
              ) : (
                ""
              )}
            </div>
          </div>
          <div className="text-[0.7rem] lg:text-xs text-gray-500">
            {formattedDate}
          </div>
          <div className="text-[0.7rem] lg:text-xs text-gray-500">
            <UploadDate timestamp={post.created_at} />, located in{" "}
            {post.location}{" "}
          </div>
        </div>
      );
    } else {
      return (
        <div className="text-xs lg:text-sm">
          {/* {post.username} */}
          <div className="flex items-center">
            <span>{post.name}</span>
            <div className="flex items-center ml-2">
              {post.verified ? (
                <img
                  className="w-3 h-3"
                  alt="verified"
                  src="../../images/icon_done.png"
                ></img>
              ) : (
                ""
              )}
            </div>
          </div>
          <div className="text-[0.7rem] lg:text-xs text-gray-500">
            {formattedDate}
          </div>
          <div className="text-[0.7rem] lg:text-xs text-gray-500">
            <UploadDate timestamp={post.created_at} />, located in{" "}
            {post.location}{" "}
          </div>
        </div>
      );
    }
  }

  function SetDefaultImage() {
    const mediaUrl =
      post.images && post.images.length > 0 ? post.images[0] : "";

    const isVideo = mediaUrl.includes("smpost-v-");
console.log(isVideo)
    return (
      <>
        <div className="flex w-full justify-center lg:w-full">
          <div className="flex">
            <div className="flex-col">
              <div
                className="w-[120px] h-[120px] lg:w-[160px] lg:h-[160px] relative bg-[#ffffff] rounded-2xl"
                style={{
                  border: "0.1px solid gainsboro",
                }}
                // onMouseEnter={() => setHovered(true)}
                // onMouseLeave={() => setHovered(false)}
              >

                {isVideo ? (
                  <video
                    className="w-full h-full object-contain rounded-2xl shadow-none"
                    src={mediaUrl}
                    muted
                    playsInline
                    preload="metadata" // Load only metadata and first frame
                    disablePictureInPicture
                    style={{ pointerEvents: "none" }} // Disable user interaction
                  />
                ) : (
                  <img
                    className="w-full h-full object-contain rounded-2xl shadow-none"
                    src={mediaUrl}
                    alt="postImage"
                  />
                )}
              </div>
              {/* icons desktop*/}
              <div className="flex text-[#C0BFBF] my-2 lg:my-4 justify-end">
                <div className="flex card-icons-map w-full justify-center items-center">
                  <div className="flex items-center">
                    <Tooltip
                      // onClick={() => handleButtonClick(post.id)}
                      title="Like"
                      className="cursor-pointer"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        // className={`h-6 w-6 transform transition-transform duration-1000 ease-in delay-150 ${
                        //   animate ? "scale-150" : ""
                        // }`}
                        className="h-6 w-6 transform transition-transform duration-1000 ease-in delay-150"
                        viewBox="0 0 20 20"
                        fill={likes ? "#FFDD43" : "currentColor"}
                      >
                        <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z"></path>
                      </svg>
                    </Tooltip>

                    <div className="flex ml-2">{totalLikes}</div>
                  </div>
                  <div className="flex items-center ml-2 lg:ml-4">
                    <Tooltip
                      onClick={handleButtonModalDetailComment}
                      title="Comment"
                      className="cursor-pointer"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        className="h-6 w-6"
                        viewBox="0 0 20 20"
                        fill="currentColor"
                      >
                        <path
                          fillRule="evenodd"
                          d="M18 10c0 3.866-3.582 7-8 7a8.841 8.841 0 01-4.083-.98L2 17l1.338-3.123C2.493 12.767 2 11.434 2 10c0-3.866 3.582-7 8-7s8 3.134 8 7zM7 9H5v2h2V9zm8 0h-2v2h2V9zM9 9h2v2H9V9z"
                          clipRule="evenodd"
                        ></path>
                      </svg>
                    </Tooltip>
                    <div className="ml-2">{post.total_comments}</div>
                  </div>
                  <div className="flex items-center ml-2 lg:ml-4">
                    <Tooltip
                      // onClick={handleCopyLink}
                      title="Share Post"
                      className="cursor-pointer"
                    >
                      <svg
                        width="22"
                        height="20"
                        viewBox="0 0 22 20"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M13.1659 0.0814048C13.3083 0.0154397 13.4674 -0.0112655 13.6251 0.00433291C13.7828 0.0199313 13.9327 0.0772059 14.0577 0.169629L21.6729 5.78386C21.7711 5.85614 21.8512 5.94803 21.9077 6.053C21.9642 6.15797 21.9955 6.27345 21.9996 6.39121C22.0036 6.50897 21.9802 6.62614 21.9311 6.73436C21.8819 6.84259 21.8082 6.93922 21.7152 7.01739L14.1 13.4337C13.978 13.5363 13.8274 13.6034 13.6662 13.6268C13.5049 13.6501 13.34 13.6289 13.1912 13.5655C13.0425 13.5021 12.9162 13.3993 12.8276 13.2695C12.7391 13.1397 12.692 12.9883 12.692 12.8337V9.71543C12.2926 9.77959 11.7714 9.89188 11.1622 10.0844C9.68486 10.5528 7.68629 11.4943 5.67587 13.4016C5.55286 13.5186 5.39472 13.5968 5.22307 13.6254C5.05141 13.6541 4.87461 13.6317 4.71684 13.5615C4.55907 13.4913 4.42802 13.3766 4.34161 13.2332C4.25519 13.0897 4.21763 12.9244 4.23406 12.7599C4.47605 10.24 5.25111 8.4017 6.3054 7.07674C7.21029 5.93313 8.44 5.05739 9.8507 4.55194C10.7606 4.22506 11.7199 4.03876 12.692 4.00014V0.803235C12.6917 0.652918 12.736 0.505542 12.8197 0.377914C12.9035 0.250286 13.0235 0.147544 13.1659 0.0814048ZM0 5.61543C0 4.55187 0.445731 3.53187 1.23914 2.77982C2.03254 2.02777 3.10863 1.60527 4.23068 1.60527H7.61522C7.83962 1.60527 8.05484 1.68977 8.21352 1.84018C8.3722 1.99059 8.46135 2.19459 8.46135 2.4073C8.46135 2.62001 8.3722 2.82401 8.21352 2.97442C8.05484 3.12483 7.83962 3.20933 7.61522 3.20933H4.23068C3.55745 3.20933 2.9118 3.46283 2.43575 3.91406C1.95971 4.3653 1.69227 4.9773 1.69227 5.61543V15.2398C1.69227 15.878 1.95971 16.49 2.43575 16.9412C2.9118 17.3924 3.55745 17.6459 4.23068 17.6459H14.3843C15.0575 17.6459 15.7032 17.3924 16.1792 16.9412C16.6553 16.49 16.9227 15.878 16.9227 15.2398V13.6358C16.9227 13.4231 17.0118 13.2191 17.1705 13.0686C17.3292 12.9182 17.5444 12.8337 17.7688 12.8337C17.9932 12.8337 18.2085 12.9182 18.3671 13.0686C18.5258 13.2191 18.615 13.4231 18.615 13.6358V15.2398C18.615 16.3034 18.1692 17.3234 17.3758 18.0754C16.5824 18.8275 15.5063 19.25 14.3843 19.25H4.23068C3.10863 19.25 2.03254 18.8275 1.23914 18.0754C0.445731 17.3234 0 16.3034 0 15.2398V5.61543Z"
                          fill="currentColor"
                        />
                      </svg>
                    </Tooltip>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }

  const handleOpenUserMenu = (event) => {
    setAnchorElPost(event.currentTarget);
  };

  const handleCloseUserMenu = () => {
    setAnchorElPost(null);
  };

  function handleOpenUpdate() {
    setAnchorElPost(null);
    setShowModalUpdate(true);
  }

  function handleCloseUpdate() {
    setShowModalUpdate(false);
  }
  function handleOpenDelete() {
    setAnchorElPost(null);
    setShowModalDelete(true);
  }

  function handleCloseDelete() {
    setShowModalDelete(false);
  }

  const handleButtonCloseUpdate = () => {
    setShowModalUpdate(false);
  };
  const handleButtonCloseDelete = () => {
    setShowModalDelete(false);
  };

  function handleButtonUpdate() {
    navigate("/update_post", { state: { post } });
  }

  const handleButtonDelete = async () => {
    try {
      await axios.delete(
        `${process.env.REACT_APP_BACKEND_DOMAIN}/api/posts/deletePost/${post.id}`,
        {
          headers: { Authorization: `Bearer ${userInfo.data.token}` },
        }
      );
      toast.success("Post deleted successfully!");
      setTimeout(() => {
        window.location.reload();
      }, 2000);
    } catch (error) {
      toast.error(getError(error));
    }
  };

  function handleButtonModalDetail() {
    navigate("/detail_post", { state: { post } });
  }

  function handleCloseSignInModalChat() {
    setShowSignInModalChat(false);
  }

  const handleCancelButtonModalChat = () => {
    setShowSignInModalChat(false);
  };

  function handleSignInButtonModalChat() {
    setShowSignInModalChat(false);
    navigate("/signin");
  }

  function nl2br(text) {
    return text.split("\n").map((line, index) => (
      <React.Fragment key={index}>
        {line}
        {index !== text.split("\n").length - 1 && <br />}
      </React.Fragment>
    ));
  }

  function handleUsername(e) {
    navigate(`/${post.username}`, { state: { e } });
  }

  useEffect(() => {
    if (!post.user_liked) {
      return;
    }

    setLikes(post.user_liked);
  }, [post]);

  function handleButtonModalDetailComment() {
    navigate(`/detail_post`, { state: { post, scrollToComments: true } });
  }

  return (
    <>
      <div key={post._id} className="overflow-auto max-h-64 w-full flex">
        <div className="grow-0 lg:mr-3">
          {post.images && post.images.length > 0 ? <SetDefaultImage /> : <></>}
        </div>

        <div className="hidden lg:block grow card-detail-map items-center justify-center w-64">
          <div className="flex" style={{ justifyContent: "space-between" }}>
            <div className="profilePost flex w-full">
              <div
                className="mr-8"
                style={{ width: "4.0em", marginRight: "2%" }}
              >
                <SetProfilePicture />
              </div>
              <div
                className="flex items-center"
                style={{ justifyContent: "center" }}
              >
                {userInfo !== null ? (
                  <>
                    {dataUser.user_id === post.user_id ? (
                      <a href={`/${dataUser.username}`}>
                        <SetUsername />
                      </a>
                    ) : (
                      <div
                        onClick={() => handleUsername(post)}
                        style={{ cursor: "pointer" }}
                      >
                        <SetUsername />
                      </div>
                    )}
                  </>
                ) : (
                  <SetUsername />
                )}
              </div>
            </div>
            {/* {dataUser.user_id === post.user_id && userInfo !== null ? (
              <div className="flex items-center">
                <Tooltip title="Edit Post">
                  <MoreVertSharpIcon
                    onClick={handleOpenUserMenu}
                    style={{ cursor: "pointer" }}
                  />
                </Tooltip>
                <Menu
                  sx={{ mt: "45px" }}
                  id="menu-appbar"
                  anchorEl={anchorElPost}
                  anchorOrigin={{
                    vertical: "top",
                    horizontal: "right",
                  }}
                  keepMounted
                  transformOrigin={{
                    vertical: "top",
                    horizontal: "right",
                  }}
                  open={Boolean(anchorElPost)}
                  onClose={handleCloseUserMenu}
                >
                  {edits.map((edit) => (
                    <MenuItem key={edit}>
                      {edit === "Update Post" ? (
                        <button onClick={handleOpenUpdate}>
                          <Typography
                            textAlign="center"
                            className="no-underline text-black"
                          >
                            {edit}
                          </Typography>{" "}
                        </button>
                      ) : (
                        <button onClick={handleOpenDelete}>
                          <Typography
                            textAlign="center"
                            className="no-underline text-black"
                          >
                            {edit}
                          </Typography>{" "}
                        </button>
                      )}
                    </MenuItem>
                  ))}
                </Menu>
              </div>
            ) : (
              ""
            )} */}
            {/* {dataUser.is_admin === true &&
            dataUser.user_id !== post.user_id &&
            userInfo !== null ? (
              <div className="flex items-center">
                <Tooltip title="Delete Post">
                  <MoreVertSharpIcon
                    onClick={handleOpenUserMenu}
                    style={{ cursor: "pointer" }}
                  />
                </Tooltip>
                <Menu
                  sx={{ mt: "45px" }}
                  id="menu-appbar"
                  anchorEl={anchorElPost}
                  anchorOrigin={{
                    vertical: "top",
                    horizontal: "right",
                  }}
                  keepMounted
                  transformOrigin={{
                    vertical: "top",
                    horizontal: "right",
                  }}
                  open={Boolean(anchorElPost)}
                  onClose={handleCloseUserMenu}
                >
                  {editsAsAdmin.map((editAsAdmin) => (
                    <MenuItem key={editAsAdmin}>
                      <button onClick={handleOpenDelete}>
                        <Typography
                          textAlign="center"
                          className="no-underline text-black"
                        >
                          {editAsAdmin}
                        </Typography>{" "}
                      </button>
                    </MenuItem>
                  ))}
                </Menu>
              </div>
            ) : (
              ""
            )} */}
          </div>

          <div className="text-xs lg:text-base">{post.posttitle}</div>

          {/* <div className="flex flex-row items-center mt-3 font-semibold text-lg">
            <div className="flex text-[#F95C3D] p-1 max-w-max mb-2 mr-2">
              {post.sd_post_type === 1
                ? "Share"
                : post.sd_post_type === 2
                ? "Seek"
                : "Unknown"}
            </div>

            <div className="flex text-[#F95C3D] p-1 max-w-max mb-2 mr-2">
              {getTypeName(post.post_type, post.sd_post_type)}
            </div>

            <div className="flex text-[#F95C3D] rounded-lg p-1 max-w-max mb-2">
              {post.category.label}
            </div>
          </div> */}

          <div className="flex justify-between">
            <div>
              {nominal ? (
                <div className="mt-3 text-base lg:text-xl font-semibold">
                  {price}
                </div>
              ) : null}
            </div>
          </div>

          {/* <div className="font-medium">
            <div>
              <ReadMore>{nl2br(post.description)}</ReadMore>
            </div>
          </div> */}

          {post.tag && Object.keys(post.tag).length > 0 ? (
            <div className="hidden lg:flex rounded-lg bg-[#dfd5d5] drop-shadow-lg mt-3 py-2 lg:p-2 overflow-x-auto">
              {Object.keys(post.tag).map((key) => (
                <div
                  className="rounded-lg text-[#F95C3D] font-bold mr-2 p-1"
                  key={key}
                >
                  {post.tag[key]}
                </div>
              ))}
            </div>
          ) : null}

          {post.images && post.images.length > 0 ? (
            <></>
          ) : (
            // icons desktop
            <div className="hidden lg:flex text-[#C0BFBF] my-4 justify-end ">
              <div className="flex px-2">
                <div className="flex items-center">
                  <Tooltip
                    // onClick={() => handleButtonClick(post.id)}
                    title="Like"
                    className="cursor-pointer"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      // className={`h-6 w-6 transform transition-transform duration-1000 ease-in delay-150 ${animate ? "scale-150" : ""
                      //   }`}
                      className="h-6 w-6 transform transition-transform duration-1000 ease-in delay-150"
                      viewBox="0 0 20 20"
                      fill={likes ? "#FFDD43" : "currentColor"}
                    >
                      <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z"></path>
                    </svg>
                  </Tooltip>

                  <div className="ml-2">{totalLikes}</div>
                </div>
                <div className="flex ml-2 lg:ml-4 items-center">
                  <Tooltip
                    onClick={handleButtonModalDetailComment}
                    title="Comment"
                    className="cursor-pointer"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      className="h-6 w-6"
                      viewBox="0 0 20 20"
                      fill="currentColor"
                    >
                      <path
                        fillRule="evenodd"
                        d="M18 10c0 3.866-3.582 7-8 7a8.841 8.841 0 01-4.083-.98L2 17l1.338-3.123C2.493 12.767 2 11.434 2 10c0-3.866 3.582-7 8-7s8 3.134 8 7zM7 9H5v2h2V9zm8 0h-2v2h2V9zM9 9h2v2H9V9z"
                        clipRule="evenodd"
                      ></path>
                    </svg>
                  </Tooltip>
                  <div className="ml-2">{post.total_comments}</div>
                </div>
                <div className="flex ml-2 lg:ml-4 items-center">
                  <Tooltip
                    // onClick={handleCopyLink}
                    title="Share Post"
                    className="cursor-pointer"
                  >
                    <svg
                      width="22"
                      height="20"
                      viewBox="0 0 22 20"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M13.1659 0.0814048C13.3083 0.0154397 13.4674 -0.0112655 13.6251 0.00433291C13.7828 0.0199313 13.9327 0.0772059 14.0577 0.169629L21.6729 5.78386C21.7711 5.85614 21.8512 5.94803 21.9077 6.053C21.9642 6.15797 21.9955 6.27345 21.9996 6.39121C22.0036 6.50897 21.9802 6.62614 21.9311 6.73436C21.8819 6.84259 21.8082 6.93922 21.7152 7.01739L14.1 13.4337C13.978 13.5363 13.8274 13.6034 13.6662 13.6268C13.5049 13.6501 13.34 13.6289 13.1912 13.5655C13.0425 13.5021 12.9162 13.3993 12.8276 13.2695C12.7391 13.1397 12.692 12.9883 12.692 12.8337V9.71543C12.2926 9.77959 11.7714 9.89188 11.1622 10.0844C9.68486 10.5528 7.68629 11.4943 5.67587 13.4016C5.55286 13.5186 5.39472 13.5968 5.22307 13.6254C5.05141 13.6541 4.87461 13.6317 4.71684 13.5615C4.55907 13.4913 4.42802 13.3766 4.34161 13.2332C4.25519 13.0897 4.21763 12.9244 4.23406 12.7599C4.47605 10.24 5.25111 8.4017 6.3054 7.07674C7.21029 5.93313 8.44 5.05739 9.8507 4.55194C10.7606 4.22506 11.7199 4.03876 12.692 4.00014V0.803235C12.6917 0.652918 12.736 0.505542 12.8197 0.377914C12.9035 0.250286 13.0235 0.147544 13.1659 0.0814048ZM0 5.61543C0 4.55187 0.445731 3.53187 1.23914 2.77982C2.03254 2.02777 3.10863 1.60527 4.23068 1.60527H7.61522C7.83962 1.60527 8.05484 1.68977 8.21352 1.84018C8.3722 1.99059 8.46135 2.19459 8.46135 2.4073C8.46135 2.62001 8.3722 2.82401 8.21352 2.97442C8.05484 3.12483 7.83962 3.20933 7.61522 3.20933H4.23068C3.55745 3.20933 2.9118 3.46283 2.43575 3.91406C1.95971 4.3653 1.69227 4.9773 1.69227 5.61543V15.2398C1.69227 15.878 1.95971 16.49 2.43575 16.9412C2.9118 17.3924 3.55745 17.6459 4.23068 17.6459H14.3843C15.0575 17.6459 15.7032 17.3924 16.1792 16.9412C16.6553 16.49 16.9227 15.878 16.9227 15.2398V13.6358C16.9227 13.4231 17.0118 13.2191 17.1705 13.0686C17.3292 12.9182 17.5444 12.8337 17.7688 12.8337C17.9932 12.8337 18.2085 12.9182 18.3671 13.0686C18.5258 13.2191 18.615 13.4231 18.615 13.6358V15.2398C18.615 16.3034 18.1692 17.3234 17.3758 18.0754C16.5824 18.8275 15.5063 19.25 14.3843 19.25H4.23068C3.10863 19.25 2.03254 18.8275 1.23914 18.0754C0.445731 17.3234 0 16.3034 0 15.2398V5.61543Z"
                        fill="currentColor"
                      />
                    </svg>
                  </Tooltip>
                </div>
              </div>
            </div>
          )}

          {/* <div className="flex justify-end items-center my-5">
            {post.contact && Object.keys(post.contact).length > 0 ? (
              <>
                <div className="flex items-center">
                  <div className="overflow-x-auto flex flex-nowrap items-center">
                    {post.contact &&
                      Object.keys(post.contact).map((contactId) => {
                        const contact = dataAllContactList.find(
                          (item) =>
                            item.id === post.contact[contactId].listcontact_id
                        );
                        return contact ? (
                          <button
                            key={contact.id}
                            onClick={() => openContact(contact.id)}
                            className="inline-flex items-center"
                          >
                            <img
                              src={
                                Array.isArray(socialMediaOptions) &&
                                socialMediaOptions.find(
                                  (option) => option.label === contact.name
                                )?.image
                              }
                              alt={contact.name}
                              className="lineButton ml-1"
                            />
                          </button>
                        ) : null;
                      })}
                  </div>
                  {post.user_id !== dataUser.user_id && (
                    <div className="divider"></div>
                  )}
                </div>
              </>
            ) : (
              ""
            )}{" "}
            {post.user_id !== dataUser.user_id && (
              <>
                <Tooltip title="Message">
                  <button
                    // onClick={handleOpenPersonalChat}
                    className="p-2"
                  >
                    <svg
                      width="30"
                      height="30"
                      viewBox="0 0 30 30"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M4.49993 24.284V30L6.77239 28.6203L13.9153 24.284H20.9997C22.6541 24.284 23.9996 22.9226 23.9996 21.2485V9.10634C23.9996 7.43224 22.6541 6.0708 20.9997 6.0708H2.99995C1.34548 6.0708 0 7.43224 0 9.10634V21.2485C0 22.9226 1.34548 24.284 2.99995 24.284H4.49993ZM2.99995 9.10634H20.9997V21.2485H13.0843L7.49988 24.6392V21.2485H2.99995V9.10634Z"
                        fill="black"
                      />
                      <path
                        d="M27.0006 0H9.00093C7.34646 0 6.00098 1.36144 6.00098 3.03554H24.0007C25.6552 3.03554 27.0006 4.39698 27.0006 6.07108V18.2132C28.6551 18.2132 30.0006 16.8518 30.0006 15.1777V3.03554C30.0006 1.36144 28.6551 0 27.0006 0Z"
                        fill="black"
                      />
                    </svg>
                  </button>
                </Tooltip>
              </>
            )}
          </div> */}

          <div className="flex text-[#C0BFBF] mt-4 justify-end">
            {!userInfo ? (
              <div
                onClick={() => setShowSignInModalChat(true)}
                className="text-[#F95C3D] cursor-pointer flex mb-2"
              >
                See details
                <div className="flex items-center ml-2">
                  <svg
                    width="10"
                    height="10"
                    viewBox="0 0 10 10"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M10 5L5.32288 0L4.2574 1.13904L7.86904 5L4.2574 8.86096L5.32288 10L10 5ZM5.7426 5L1.06548 0L0 1.13904L3.61163 5L0 8.86096L1.06548 10L5.7426 5Z"
                      fill="#F95C3D"
                    />
                  </svg>
                </div>
              </div>
            ) : (
              <div
                onClick={handleButtonModalDetail}
                className="text-[#F95C3D] cursor-pointer flex mb-2"
              >
                See details
                <div className="flex items-center ml-2">
                  <svg
                    width="10"
                    height="10"
                    viewBox="0 0 10 10"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M10 5L5.32288 0L4.2574 1.13904L7.86904 5L4.2574 8.86096L5.32288 10L10 5ZM5.7426 5L1.06548 0L0 1.13904L3.61163 5L0 8.86096L1.06548 10L5.7426 5Z"
                      fill="#F95C3D"
                    />
                  </svg>
                </div>
              </div>
            )}
          </div>
        </div>
        <div className="grow card-detail-map-mobile lg:hidden items-center justify-center w-64">
          <div className="flex" style={{ justifyContent: "space-between" }}>
            <div className="profilePost flex w-full">
              <div
                className="mr-8"
                style={{ width: "4.0em", marginRight: "2%" }}
              >
                <SetProfilePicture />
              </div>
              <div
                className="flex items-center"
                style={{ justifyContent: "center" }}
              >
                {userInfo !== null ? (
                  <>
                    {dataUser.user_id === post.user_id ? (
                      <a href={`/${dataUser.username}`}>
                        <SetUsername />
                      </a>
                    ) : (
                      <div
                        onClick={() => handleUsername(post)}
                        style={{ cursor: "pointer" }}
                      >
                        <SetUsername />
                      </div>
                    )}
                  </>
                ) : (
                  <SetUsername />
                )}
              </div>
            </div>
            {/* {dataUser.user_id === post.user_id && userInfo !== null ? (
              <div className="flex items-center">
                <Tooltip title="Edit Post">
                  <MoreVertSharpIcon
                    onClick={handleOpenUserMenu}
                    style={{ cursor: "pointer" }}
                  />
                </Tooltip>
                <Menu
                  sx={{ mt: "45px" }}
                  id="menu-appbar"
                  anchorEl={anchorElPost}
                  anchorOrigin={{
                    vertical: "top",
                    horizontal: "right",
                  }}
                  keepMounted
                  transformOrigin={{
                    vertical: "top",
                    horizontal: "right",
                  }}
                  open={Boolean(anchorElPost)}
                  onClose={handleCloseUserMenu}
                >
                  {edits.map((edit) => (
                    <MenuItem key={edit}>
                      {edit === "Update Post" ? (
                        <button onClick={handleOpenUpdate}>
                          <Typography
                            textAlign="center"
                            className="no-underline text-black"
                          >
                            {edit}
                          </Typography>{" "}
                        </button>
                      ) : (
                        <button onClick={handleOpenDelete}>
                          <Typography
                            textAlign="center"
                            className="no-underline text-black"
                          >
                            {edit}
                          </Typography>{" "}
                        </button>
                      )}
                    </MenuItem>
                  ))}
                </Menu>
              </div>
            ) : (
              ""
            )} */}
            {/* {dataUser.is_admin === true &&
            dataUser.user_id !== post.user_id &&
            userInfo !== null ? (
              <div className="flex items-center">
                <Tooltip title="Delete Post">
                  <MoreVertSharpIcon
                    onClick={handleOpenUserMenu}
                    style={{ cursor: "pointer" }}
                  />
                </Tooltip>
                <Menu
                  sx={{ mt: "45px" }}
                  id="menu-appbar"
                  anchorEl={anchorElPost}
                  anchorOrigin={{
                    vertical: "top",
                    horizontal: "right",
                  }}
                  keepMounted
                  transformOrigin={{
                    vertical: "top",
                    horizontal: "right",
                  }}
                  open={Boolean(anchorElPost)}
                  onClose={handleCloseUserMenu}
                >
                  {editsAsAdmin.map((editAsAdmin) => (
                    <MenuItem key={editAsAdmin}>
                      <button onClick={handleOpenDelete}>
                        <Typography
                          textAlign="center"
                          className="no-underline text-black"
                        >
                          {editAsAdmin}
                        </Typography>{" "}
                      </button>
                    </MenuItem>
                  ))}
                </Menu>
              </div>
            ) : (
              ""
            )} */}
          </div>

          <div className="text-xs lg:text-base">{post.posttitle}</div>

          {/* <div className="flex flex-row items-center mt-3 font-semibold text-lg">
            <div className="flex text-[#F95C3D] p-1 max-w-max mb-2 mr-2">
              {post.sd_post_type === 1
                ? "Share"
                : post.sd_post_type === 2
                ? "Seek"
                : "Unknown"}
            </div>

            <div className="flex text-[#F95C3D] p-1 max-w-max mb-2 mr-2">
              {getTypeName(post.post_type, post.sd_post_type)}
            </div>

            <div className="flex text-[#F95C3D] rounded-lg p-1 max-w-max mb-2">
              {post.category.label}
            </div>
          </div> */}

          <div className="flex justify-between">
            <div>
              {nominal ? (
                <div className="mt-3 text-base lg:text-xl font-semibold">
                  {price}
                </div>
              ) : null}
            </div>
          </div>

          {/* <div className="font-medium">
            <div>
              <ReadMore>{nl2br(post.description)}</ReadMore>
            </div>
          </div> */}

          {post.tag && Object.keys(post.tag).length > 0 ? (
            <div className="hidden lg:flex rounded-lg bg-[#dfd5d5] drop-shadow-lg mt-3 py-2 lg:p-2 overflow-x-auto">
              {Object.keys(post.tag).map((key) => (
                <div
                  className="rounded-lg text-[#F95C3D] font-bold mr-2 p-1"
                  key={key}
                >
                  {post.tag[key]}
                </div>
              ))}
            </div>
          ) : null}

          {post.images && post.images.length > 0 ? (
            <></>
          ) : (
            // icons desktop
            <div className="hidden lg:flex text-[#C0BFBF] my-4 justify-end ">
              <div className="flex px-2">
                <div className="flex items-center">
                  <Tooltip
                    // onClick={() => handleButtonClick(post.id)}
                    title="Like"
                    className="cursor-pointer"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      // className={`h-6 w-6 transform transition-transform duration-1000 ease-in delay-150 ${animate ? "scale-150" : ""
                      //   }`}
                      className="h-6 w-6 transform transition-transform duration-1000 ease-in delay-150"
                      viewBox="0 0 20 20"
                      fill={likes ? "#FFDD43" : "currentColor"}
                    >
                      <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z"></path>
                    </svg>
                  </Tooltip>

                  <div className="ml-2">{totalLikes}</div>
                </div>
                <div className="flex ml-2 lg:ml-4 items-center">
                  <Tooltip
                    onClick={handleButtonModalDetailComment}
                    title="Comment"
                    className="cursor-pointer"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      className="h-6 w-6"
                      viewBox="0 0 20 20"
                      fill="currentColor"
                    >
                      <path
                        fillRule="evenodd"
                        d="M18 10c0 3.866-3.582 7-8 7a8.841 8.841 0 01-4.083-.98L2 17l1.338-3.123C2.493 12.767 2 11.434 2 10c0-3.866 3.582-7 8-7s8 3.134 8 7zM7 9H5v2h2V9zm8 0h-2v2h2V9zM9 9h2v2H9V9z"
                        clipRule="evenodd"
                      ></path>
                    </svg>
                  </Tooltip>
                  <div className="ml-2">{post.total_comments}</div>
                </div>
                <div className="flex ml-2 lg:ml-4 items-center">
                  <Tooltip
                    // onClick={handleCopyLink}
                    title="Share Post"
                    className="cursor-pointer"
                  >
                    <svg
                      width="22"
                      height="20"
                      viewBox="0 0 22 20"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M13.1659 0.0814048C13.3083 0.0154397 13.4674 -0.0112655 13.6251 0.00433291C13.7828 0.0199313 13.9327 0.0772059 14.0577 0.169629L21.6729 5.78386C21.7711 5.85614 21.8512 5.94803 21.9077 6.053C21.9642 6.15797 21.9955 6.27345 21.9996 6.39121C22.0036 6.50897 21.9802 6.62614 21.9311 6.73436C21.8819 6.84259 21.8082 6.93922 21.7152 7.01739L14.1 13.4337C13.978 13.5363 13.8274 13.6034 13.6662 13.6268C13.5049 13.6501 13.34 13.6289 13.1912 13.5655C13.0425 13.5021 12.9162 13.3993 12.8276 13.2695C12.7391 13.1397 12.692 12.9883 12.692 12.8337V9.71543C12.2926 9.77959 11.7714 9.89188 11.1622 10.0844C9.68486 10.5528 7.68629 11.4943 5.67587 13.4016C5.55286 13.5186 5.39472 13.5968 5.22307 13.6254C5.05141 13.6541 4.87461 13.6317 4.71684 13.5615C4.55907 13.4913 4.42802 13.3766 4.34161 13.2332C4.25519 13.0897 4.21763 12.9244 4.23406 12.7599C4.47605 10.24 5.25111 8.4017 6.3054 7.07674C7.21029 5.93313 8.44 5.05739 9.8507 4.55194C10.7606 4.22506 11.7199 4.03876 12.692 4.00014V0.803235C12.6917 0.652918 12.736 0.505542 12.8197 0.377914C12.9035 0.250286 13.0235 0.147544 13.1659 0.0814048ZM0 5.61543C0 4.55187 0.445731 3.53187 1.23914 2.77982C2.03254 2.02777 3.10863 1.60527 4.23068 1.60527H7.61522C7.83962 1.60527 8.05484 1.68977 8.21352 1.84018C8.3722 1.99059 8.46135 2.19459 8.46135 2.4073C8.46135 2.62001 8.3722 2.82401 8.21352 2.97442C8.05484 3.12483 7.83962 3.20933 7.61522 3.20933H4.23068C3.55745 3.20933 2.9118 3.46283 2.43575 3.91406C1.95971 4.3653 1.69227 4.9773 1.69227 5.61543V15.2398C1.69227 15.878 1.95971 16.49 2.43575 16.9412C2.9118 17.3924 3.55745 17.6459 4.23068 17.6459H14.3843C15.0575 17.6459 15.7032 17.3924 16.1792 16.9412C16.6553 16.49 16.9227 15.878 16.9227 15.2398V13.6358C16.9227 13.4231 17.0118 13.2191 17.1705 13.0686C17.3292 12.9182 17.5444 12.8337 17.7688 12.8337C17.9932 12.8337 18.2085 12.9182 18.3671 13.0686C18.5258 13.2191 18.615 13.4231 18.615 13.6358V15.2398C18.615 16.3034 18.1692 17.3234 17.3758 18.0754C16.5824 18.8275 15.5063 19.25 14.3843 19.25H4.23068C3.10863 19.25 2.03254 18.8275 1.23914 18.0754C0.445731 17.3234 0 16.3034 0 15.2398V5.61543Z"
                        fill="currentColor"
                      />
                    </svg>
                  </Tooltip>
                </div>
              </div>
            </div>
          )}

          {/* <div className="flex justify-end items-center my-5">
            {post.contact && Object.keys(post.contact).length > 0 ? (
              <>
                <div className="flex items-center">
                  <div className="overflow-x-auto flex flex-nowrap items-center">
                    {post.contact &&
                      Object.keys(post.contact).map((contactId) => {
                        const contact = dataAllContactList.find(
                          (item) =>
                            item.id === post.contact[contactId].listcontact_id
                        );
                        return contact ? (
                          <button
                            key={contact.id}
                            onClick={() => openContact(contact.id)}
                            className="inline-flex items-center"
                          >
                            <img
                              src={
                                Array.isArray(socialMediaOptions) &&
                                socialMediaOptions.find(
                                  (option) => option.label === contact.name
                                )?.image
                              }
                              alt={contact.name}
                              className="lineButton ml-1"
                            />
                          </button>
                        ) : null;
                      })}
                  </div>
                  {post.user_id !== dataUser.user_id && (
                    <div className="divider"></div>
                  )}
                </div>
              </>
            ) : (
              ""
            )}{" "}
            {post.user_id !== dataUser.user_id && (
              <>
                <Tooltip title="Message">
                  <button
                    // onClick={handleOpenPersonalChat}
                    className="p-2"
                  >
                    <svg
                      width="30"
                      height="30"
                      viewBox="0 0 30 30"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M4.49993 24.284V30L6.77239 28.6203L13.9153 24.284H20.9997C22.6541 24.284 23.9996 22.9226 23.9996 21.2485V9.10634C23.9996 7.43224 22.6541 6.0708 20.9997 6.0708H2.99995C1.34548 6.0708 0 7.43224 0 9.10634V21.2485C0 22.9226 1.34548 24.284 2.99995 24.284H4.49993ZM2.99995 9.10634H20.9997V21.2485H13.0843L7.49988 24.6392V21.2485H2.99995V9.10634Z"
                        fill="black"
                      />
                      <path
                        d="M27.0006 0H9.00093C7.34646 0 6.00098 1.36144 6.00098 3.03554H24.0007C25.6552 3.03554 27.0006 4.39698 27.0006 6.07108V18.2132C28.6551 18.2132 30.0006 16.8518 30.0006 15.1777V3.03554C30.0006 1.36144 28.6551 0 27.0006 0Z"
                        fill="black"
                      />
                    </svg>
                  </button>
                </Tooltip>
              </>
            )}
          </div> */}

          <div className="flex text-[#C0BFBF] mt-4 justify-end">
            {!userInfo ? (
              <div
                onClick={() => setShowSignInModalChat(true)}
                className="text-[#F95C3D] cursor-pointer flex mb-2"
              >
                See details
                <div className="flex items-center ml-2">
                  <svg
                    width="10"
                    height="10"
                    viewBox="0 0 10 10"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M10 5L5.32288 0L4.2574 1.13904L7.86904 5L4.2574 8.86096L5.32288 10L10 5ZM5.7426 5L1.06548 0L0 1.13904L3.61163 5L0 8.86096L1.06548 10L5.7426 5Z"
                      fill="#F95C3D"
                    />
                  </svg>
                </div>
              </div>
            ) : (
              <div
                onClick={handleButtonModalDetail}
                className="text-[#F95C3D] cursor-pointer flex mb-2"
              >
                See details
                <div className="flex items-center ml-2">
                  <svg
                    width="10"
                    height="10"
                    viewBox="0 0 10 10"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M10 5L5.32288 0L4.2574 1.13904L7.86904 5L4.2574 8.86096L5.32288 10L10 5ZM5.7426 5L1.06548 0L0 1.13904L3.61163 5L0 8.86096L1.06548 10L5.7426 5Z"
                      fill="#F95C3D"
                    />
                  </svg>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>

      <Modal
        open={showSignInModalChat}
        onClose={handleCloseSignInModalChat}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box className="modal-notification-style">
          <Typography
            id="modal-modal-title"
            variant="h6"
            component="h2"
            style={{
              marginBottom: "10%",
              marginTop: "5%",
              textAlign: "center",
            }}
          >
            Sign in to use this feature
          </Typography>
          <div className="flex justify-center">
            <button
              type="button"
              className="py-2 px-4 rounded-lg text-sm bg-[#F95C3D] text-white shadow hover:bg-orange-600 outline-none focus:outline-none mr-2 mb-1 ease-linear transition-all duration-150"
              onClick={handleSignInButtonModalChat}
            >
              Sign in
            </button>
            <button
              type="button"
              className="py-2 px-4 rounded-lg text-sm bg-white text-[#F95C3D] shadow hover:bg-[#F5F5F5] outline-none focus:outline-none ml-2 mb-1 ease-linear transition-all duration-150"
              onClick={handleCancelButtonModalChat}
            >
              Cancel
            </button>
          </div>
        </Box>
      </Modal>
    </>
  );
}
